import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WithdrawalsApiAdapter } from '../adapters';
import { WithdrawalsFilters, WithdrawalsResponse } from '../models';

const DEFAULT_FILTERS: WithdrawalsFilters = {};

export const WITHDRAWALS_QUERY_KEY = 'withdrawals';

export const useWithdrawals = (
    walletId: number | null | undefined,
    filters?: WithdrawalsFilters
) => {
    const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
    const apiAdapter = useMemo(() => new WithdrawalsApiAdapter(httpClient), [httpClient]);
    const resolvedFilters = filters ?? DEFAULT_FILTERS;

    return useQuery<WithdrawalsResponse, Error>({
        queryKey: [WITHDRAWALS_QUERY_KEY, walletId, resolvedFilters],
        queryFn: () => apiAdapter.getWithdrawals(walletId ?? null, resolvedFilters),
        staleTime: 60 * 1000,
        placeholderData: keepPreviousData,
    });
};

